const modulo = "blog"
const main_data = {
    key_interfaz: `tabla_${modulo}`,
    key_esquema: modulo.toUpperCase(),
    module: modulo
}

module.exports = {
    main_data
}